import React from 'react'
import { Button } from 'react-bootstrap'
import { FooterText, Text, Wrapper } from '../../styled'
import { YouTubeWrapper } from './styled'
import { SubmitButtonStyles } from '../EnterMailbox/styled'

export const CreateAppPassword = ({ email, nextStep, provider }) => {
  let link = ''
  switch (provider) {
    case 'yahoo':
      link =
        'https://login.yahoo.com/myaccount/security/app-password-generate?scrumb=1vrFuZ2KRfW&backTo=%2Fsecurity%3F.scrumb%3D1vrFuZ2KRfW'
      break
    case 'google':
      link = 'https://myaccount.google.com/apppasswords'
      break
    default:
      link = 'https://appleid.apple.com/account/manage'
      break
  }

  const handleButtonClick = () => {
    nextStep()
  }

  const providerLabel =
    provider === 'icloud'
      ? 'iCloud'
      : provider.charAt(0).toUpperCase() + provider.substring(1)

  return (
    <Wrapper>
      <Text style={{ width: '445px', maxWidth: '445px' }}>
        Create {providerLabel} App Password for
        <br />
        <b>{email}</b>
      </Text>
      {provider === 'yahoo' ? (
        <div>
          <Text>
            <b>Step 1:</b> While under "Security", down to "External
            connections" and select "App Passwords".
          </Text>
          <Text>
            <b>Step 2:</b> On the right side, select "Create app password", and
            enter Unroll.Me in when prompted for an app name and click "Generate
            password". Copy the App Password that is displayed.
          </Text>
        </div>
      ) : (
        <YouTubeWrapper
          src={
            provider === 'google'
              ? 'https://www.youtube.com/embed/RPivqAyLfHM'
              : 'https://www.youtube.com/embed/GE-LiLoDj9g'
          }
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      )}
      <Button style={SubmitButtonStyles} target="_blank" href={link}>
        Create App Password
      </Button>
      <FooterText onClick={handleButtonClick}>
        App Password Already Created
      </FooterText>
    </Wrapper>
  )
}
